var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7089 3.66675H17.7228V4.88897H19.5561V18.3334H2.44504V4.88897H4.27837V3.66675H2.29226C2.1494 3.66914 2.00842 3.69964 1.87735 3.75653C1.74629 3.81341 1.62772 3.89555 1.52841 3.99827C1.4291 4.10099 1.35099 4.22226 1.29856 4.35517C1.24612 4.48807 1.22039 4.63 1.22281 4.77286V18.4495C1.22039 18.5924 1.24612 18.7343 1.29856 18.8672C1.35099 19.0001 1.4291 19.1214 1.52841 19.2241C1.62772 19.3268 1.74629 19.409 1.87735 19.4659C2.00842 19.5227 2.1494 19.5532 2.29226 19.5556H19.7089C19.8518 19.5532 19.9928 19.5227 20.1238 19.4659C20.2549 19.409 20.3735 19.3268 20.4728 19.2241C20.5721 19.1214 20.6502 19.0001 20.7026 18.8672C20.7551 18.7343 20.7808 18.5924 20.7784 18.4495V4.77286C20.7808 4.63 20.7551 4.48807 20.7026 4.35517C20.6502 4.22226 20.5721 4.10099 20.4728 3.99827C20.3735 3.89555 20.2549 3.81341 20.1238 3.75653C19.9928 3.69964 19.8518 3.66914 19.7089 3.66675Z",
    fill: "#9D9FA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88867 8.55566H6.11089V9.77789H4.88867V8.55566Z",
    fill: "#9D9FA2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55469 8.55566H9.77691V9.77789H8.55469V8.55566Z",
    fill: "#9D9FA2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2227 8.55566H13.4449V9.77789H12.2227V8.55566Z",
    fill: "#9D9FA2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8887 8.55566H17.1109V9.77789H15.8887V8.55566Z",
    fill: "#9D9FA2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88867 11.6111H6.11089V12.8333H4.88867V11.6111Z",
    fill: "#9D9FA2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55469 11.6111H9.77691V12.8333H8.55469V11.6111Z",
    fill: "#9D9FA2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2227 11.6111H13.4449V12.8333H12.2227V11.6111Z",
    fill: "#9D9FA2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8887 11.6111H17.1109V12.8333H15.8887V11.6111Z",
    fill: "#9D9FA2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88867 14.6667H6.11089V15.889H4.88867V14.6667Z",
    fill: "#9D9FA2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55469 14.6667H9.77691V15.889H8.55469V14.6667Z",
    fill: "#9D9FA2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2227 14.6667H13.4449V15.889H12.2227V14.6667Z",
    fill: "#9D9FA2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8887 14.6667H17.1109V15.889H15.8887V14.6667Z",
    fill: "#9D9FA2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11111 6.11106C6.27319 6.11106 6.42863 6.04667 6.54323 5.93207C6.65784 5.81746 6.72222 5.66202 6.72222 5.49995V1.83328C6.72222 1.6712 6.65784 1.51576 6.54323 1.40116C6.42863 1.28655 6.27319 1.22217 6.11111 1.22217C5.94903 1.22217 5.7936 1.28655 5.67899 1.40116C5.56438 1.51576 5.5 1.6712 5.5 1.83328V5.49995C5.5 5.66202 5.56438 5.81746 5.67899 5.93207C5.7936 6.04667 5.94903 6.11106 6.11111 6.11106Z",
    fill: "#9D9FA2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8885 6.11106C16.0505 6.11106 16.206 6.04667 16.3206 5.93207C16.4352 5.81746 16.4996 5.66202 16.4996 5.49995V1.83328C16.4996 1.6712 16.4352 1.51576 16.3206 1.40116C16.206 1.28655 16.0505 1.22217 15.8885 1.22217C15.7264 1.22217 15.5709 1.28655 15.4563 1.40116C15.3417 1.51576 15.2773 1.6712 15.2773 1.83328V5.49995C15.2773 5.66202 15.3417 5.81746 15.4563 5.93207C15.5709 6.04667 15.7264 6.11106 15.8885 6.11106Z",
    fill: "#9D9FA2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4H14.1111V5.22222H8V4Z",
    fill: "#9D9FA2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.075c2dffed624da4e4193a0b76f95ba4.svg";
export { ForwardRef as ReactComponent };